<template>
  <div>
    <!-- :rules="rules" -->
    <el-form :inline="true" :model="formInline.t" class="user-search" ref="form" >
      <el-form-item prop="operatorId">
        <el-cascader  size="mini" clearable  ref="cascader"
                      placeholder="运营商" filterable
                      :options="operatorsTree"
                      :props="{ checkStrictly:true,expandTrigger:'hover'}"
                      :show-all-levels="false"
                      change-on-select
                      @change='handChangeOperator'
                      v-model="formInline.t.operatorId">
        </el-cascader>
      </el-form-item>
      <el-form-item prop="stationId">
        <el-select placeholder="场站名称" filterable v-model="formInline.t.stationId" clearable>
          <el-option v-for="item in stationsForSelect" :key="item.id"
                     v-bind:label="item.stationName" v-bind:value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
        <el-button size="mini" type="primary" :loading='loading' icon="el-icon-search" @click="search">查询</el-button>

        <template v-if="checkPermission(['bee:res:handProfit:saveOrUpdateHandProfit'])">
          <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAdd()">{{ $t('deviceControl.Add') }}</el-button>
        </template>

      </el-form-item>
      <el-form-item >
        <ElMultipleSelect
          size="mini"
          :placeholder="$t('qing-xuan-ze-dao-chu-de-bao-biao-zi-duan')"
          v-model="formInline.t.exportColumn"
          :list="reportColumns"
          :props="{label:'message'}"
        ></ElMultipleSelect>
        <el-button size="mini" type="primary" icon="el-icon-download" v-if="checkPermission(['bee:res:handProfit:excel'])" @click="exportRecordData">{{ $t('excel-dao-chu') }}</el-button>
      </el-form-item>
    </el-form>

    <el-table @selection-change="selectChange"
              :data="userData"
              highlight-current-row
              v-loading="loading"
              border
              :element-loading-text="$t('paramMonitor.Loading')"
              style="width: 100%;">

      <af-table-column prop="profitOrderNo"  label="分账单号" width="250px"></af-table-column>
      <af-table-column prop="operatorName"  label="运营商名称" width="200px"></af-table-column>
      <af-table-column prop="stationCode"  label="场站编码" width="150px"></af-table-column>
      <af-table-column prop="stationName"  label="场站名称" width="250px"></af-table-column>
      <af-table-column prop="status"  label="分润状态" ></af-table-column>
      <af-table-column prop="totalFee"  label="总金额"></af-table-column>
      <af-table-column prop="electricityFee"  label="充电电费（含手续费）"></af-table-column>
      <af-table-column prop="operatingCosts"  label="运营成本（含手续费）"></af-table-column>
      <af-table-column prop="electricityServiceFee"  label="可分润服务费"></af-table-column>
      <af-table-column prop="takeUpPileAmount"  label="可分润服务费中占桩费"></af-table-column>
      <af-table-column prop="platformCommission"  label="从可分润服务费抽成"></af-table-column>
      <af-table-column prop="commission"  label="支付手续费"></af-table-column>
      <af-table-column prop="commissionDifferenceFee"  label="支付手续费差额"></af-table-column>
      <af-table-column prop="stationRevenue"  label="场站收益"></af-table-column>
      <af-table-column prop="profitStartTime"  label="分润开始时间"></af-table-column>
      <af-table-column prop="profitEndTime"  label="分润结束时间"></af-table-column>
      <af-table-column prop="createTime"  label="创建时间"></af-table-column>
      <af-table-column prop="remarks"  label="备注" width="250px"></af-table-column>

      <af-table-column label="操作" width="250px">
        <template slot-scope="scope">
          <template v-if="checkPermission(['bee:res:handProfit:deleteHandProfit'])">
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
          <el-button
            v-if="checkPermission(['bee:order:chargingRequest:excel'])"
            type="primary"
            icon="el-icon-download"
            :loading="exportLoading"
            @click="exportData(scope.$index, scope.row)"
          >订单明细导出</el-button
          >
        </template>
      </af-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination :child-msg="pageParam" @callFather="callFather"></Pagination>

    <!-- 添加界面 -->
    <add-page
      :form-visible="addFormVisible"
      :stationsForSelect="stationsForSelect"
      :operatorsTree="operatorsTree"
      @closeDialog="closeDialog"
      @afterAdd="afterAdd"
    ></add-page>
  </div>
</template>

<script>
  import Pagination from '@/module/cardManage/component/Pagination.vue'
  import addPage from '@/module/resourceCenter/page/handProfit/add.vue'
  import api from '@/module/resourceCenter/api/handProfit.js'
  import report from "@/module/dataCenter/api/report.js";
  import common from '@/common/api/commonApi.js'
  import commonApi from "@/module/resourceCenter/api/commonApi";
  import ElMultipleSelect from "@/components/ElMultipleSelect"
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        operatorsTree: [],
        operatorIds: [],
        addFormVisible: false,
        updateFormVisible: false,
        detailFormVisible: false,
        exportLoading: false,
        loading: false, // 是显示加载
        searchLoading: false,
        stationsForSelect: "",
        customers: [],
        // 选择数据
        selectData: [],
        // 请求数据参数
        formInline: {
          t: {
            operatorId: '',
            name: null,
            exportColumn: []
          }
        },
        reportColumns: [],
        // 分页参数
        pageParam: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        // 列表数据
        userData: [],
        // 选中列数据
        selectRowData: {
          operator:null,
          memberDiscount: null
        },
      }
    },
    // 注册组件
    components: {
      Pagination,
      addPage,
      ElMultipleSelect,
    },
    computed: {
      ...mapGetters(["operatorId"]),
    },
    mounted() {
      this.search()
      this.getOperatorsTree()
      this.getReportColumns();
    },
    watch: {},
    methods: {
      //获取运营商树
      getOperatorsTree() {
        let params = JSON.stringify({});
        common.getOperatorsTree(params).then((res) => {
          this.operatorsTree = res.data
        })
      },
      handChangeOperator(value){
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.formInline.t.operatorId = operatorId
        commonApi.stationsForSelectByOperatorId(value).then((res) => {
          if (res.code === 0) {
            this.stationsForSelect = res.data;
          }
        });
        this.$refs.cascader.dropDownVisible = false
      },
      handleDelete(index, row) {
        if (!row) {
          return
        }
        this.$confirm(this.$t('ci-cao-zuo-jiang-yong-jiu-shan-chu-gai-ji-lu-shi-fou-ji-xu'), this.$t('deviceControl.prompt'), {
          confirmButtonText: this.$t('deviceControl.confirm'),
          cancelButtonText: this.$t('alaramMonitor.cancel'),
          type: 'warning'
        }).then(() => {
          api.delete(row.id).then(res => {
            this.$message({
              type: 'success',
              message: this.$t('shan-chu-cheng-gong-0')
            })
            this.search()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('yi-qu-xiao-shan-chu')
          })
        })
      },
      // 获取数据方法
      getData(parameter) {
        this.loading = true
        api.getPage(JSON.stringify(parameter)).then((res) => {
          console.info("res:"+JSON.stringify(res))
          this.userData = res.data.records
          // 分页赋值
          this.pageParam.currentPage = res.data.pageNum
          this.pageParam.total = res.data.total

          // 加载结束
          this.loading = false
        }).catch(error => {
          this.loading = false
        })
      },
      // 分页插件事件
      callFather() {
        let data = {
          currentPage: this.pageParam.currentPage,
          pageSize: this.pageParam.pageSize,
          t: this.formInline.t
        }
        this.getData(data)
      },
      resetSearchForm() {
        this.operatorIds = []
        this.formInline.t = {}
        this.search()
      },
      // 搜索事件
      search() {
        this.$refs['form'].validate(valid => {
          if (!valid) {
            return false
          }
          this.getData(this.formInline)
        })
      },
      // 添加
      handleAdd: function () {
        this.addFormVisible = true
      },
      // 选择复选框事件
      selectChange(val) {
        this.selectData = val
      },
      // 更新成功之后的操作
      afterUpdate() {
        this.updateFormVisible = false
        this.callFather()
      },
      // 添加成功后操作
      afterAdd() {
        this.addFormVisible = false
        this.search()
      },
      // 关闭弹框
      closeDialog(type) {
        console.log('type:' + type)
        if (type === 'update') {
          this.updateFormVisible = false
        } else if (type === 'add') {
          this.addFormVisible = false
        } else if (type === 'detail') {
          this.detailFormVisible = false
        }
      },
      async getReportColumns() {
        const {data} = await api.getReportRecordColumns()
        this.reportColumns = data
      },
      exportRecordData() {
        this.$refs.form.validate((valid) => { // 校验
          if (valid) {
            this.exportLoading = true
            api.recordReport(this.formInline.t).then(res => {
              const blob = new Blob([res],{
                type: 'application/vnd.ms-excel;charset=utf-8'
              })
              const downloadElement = document.createElement('a')
              const href = window.URL.createObjectURL(blob)
              downloadElement.download = "手动分润信息.xlsx"
              downloadElement.href = href
              document.body.appendChild(downloadElement)
              downloadElement.click()
              document.body.removeChild(downloadElement) // 下载完成移除元素
              window.URL.revokeObjectURL(href) // 释放掉blob对象
            }).finally(() => {
              this.exportLoading = false
            })
          }
        })
      },
      async exportData(index, row) {
        console.log("导出");
        this.exportLoading =  true;
        let param = {
          orderState: 9,
          electricityUp: 1,
          opeartorId: row.opeartorId,
          stationCode: row.stationCode,
          startDate:row.profitStartTime,
          endDate:row.profitEndTime
        };
        report.downloadOrder(param).then((res) => {
          if (res) {
            this.downloadExcel(res, this.$t('ding-dan-liu-shui'));
            this.exportLoading =  false;
          }else{
            this.exportLoading =  false;
          }
        });
      },
      //下载excel,res为要导出的内容，name为文件名
      downloadExcel(res, name) {
        const blob = new Blob([res], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        // 创建一个超链接a标签
        const downloadElement = document.createElement("a");
        const href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = name + ".xlsx";
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/handProfit/list.vue